// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"3cdb9654","484":"24bd4bd9","498":"14617ea7","555":"e739be47","616":"af433c40","629":"cf3d5130","640":"0d393154","686":"9e4719c0","869":"08dbb97c","923":"13f36a05","974":"93042965"}[chunkId] + ".chunk.js";
};